import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();
const base = '/api/v1/contacts';
const baseBlock = '/api/v1/purple-post/block-list';

export default {
  getAll(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/mdm-user${queryString}`);
  },
  blockContact(userId, reason) {
    return axios.post(`${baseBlock}/block`, {
      user_id: userId,
      reason,
      blocked_by: 'Prisoner',
    });
  },
  unBlockContact(userId) {
    return axios.delete(`${baseBlock}/remove-block/${userId}`);
  },
};
